import styled from '@emotion/styled';
import { Button } from 'components/Buttons';

export const SwitchesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 0.5em;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  .gps_compliant_switch {
    order: 999;
  }
`;

export const FilterItem = styled.div`
  margin-bottom: 0.6em;
`;

export const MoreButton = styled(Button)``;
